import React, { useState } from 'react';
import CobuConstants from '~/helpers/cobuConstants';
import styles from './ManageWordsForm.module.css';

type ManageWordFormProps = {
  isUpdate?: boolean;
  onPressCancel: () => void;
  term?: string;
  onSubmit: (term: string) => void;
};

export default function ManageWordForm({ isUpdate = false, onPressCancel, term='', onSubmit }: ManageWordFormProps) {
  const [currentTerm, setCurrentTerm] = useState(term);

  return (
    <form onSubmit={handleSubmit}>
      <div className='item'>
        <label htmlFor='title'>Term</label>
        <input
          type='text'
          onChange={(e) => setCurrentTerm(e.target.value)}
          value={currentTerm}
          className={styles.capitalizeInput}
        />
      </div>
      <div className='formButtons'>
          <button className='btn-standard btn-secondary' onClick={onPressCancel}>
            {CobuConstants.manageWords.cancel}
          </button>
          <button
            className='btn-standard btn-primary margin-left-16 '
            type='submit'
          >
            {isUpdate ? CobuConstants.manageWords.update : CobuConstants.manageWords.create}
          </button>
        </div>
    </form>
  );

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    onSubmit(currentTerm);
  }
}
